import PHQData from './PHQData';
import FreeFormTexts from './FreeFormTexts';
import ParticipantInfo from './ParticipantInfo';

export default {
  PHQData,
  FreeFormTexts,
  ParticipantInfo,
};
